<template>
    <div>
        <kgr-form-scaffold
            :pending="loading || pending"
            :with-delete-button="false"
            :with-back-button="false"
            @primaryBtnClicked="save"
        >
            <kgr-loading v-if="loading" />
            <kgr-table v-else class="kgr-table--block">
                <thead>
                    <tr class="kgr-table__row">
                        <kgr-th sortable>
                            {{ $t('Name der Einrichtung') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Einrichtungsart') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Adresse') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Bundesland') }}
                        </kgr-th>
                        <kgr-th sortable>
                            {{ $t('Leitung') }}
                        </kgr-th>
                        <kgr-th>
                            <kgr-checkbox
                                v-model="selectAllEditableVacationRequests"
                                :inline="true"
                                @change="toggleEditableVacationRequests()"
                            />
                            {{ $t('Urlaubsanträge bearbeiten') }}
                        </kgr-th>
                    </tr>
                </thead>
                <tbody v-if="kindergartenConfigs.length > 0">
                    <tr
                        v-for="(kindergartenConfig, index) in kindergartenConfigs"
                        :key="index"
                        class="kgr-table__row"
                    >
                        <td class="kgr-table__cell">
                            {{ kindergartenConfig.kindergarten.name }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ translateKindergartenType(kindergartenConfig.kindergarten.kindergartenType) }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ kindergartenConfig.kindergarten.concatAddress() }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ translateFederalState(kindergartenConfig.kindergarten.federalState) }}
                        </td>
                        <td class="kgr-table__cell">
                            {{ kindergartenConfig.kindergarten.executive }}
                        </td>
                        <td class="kgr-table__cell">
                            <kgr-checkbox
                                v-model="kindergartenConfig.editableVacationRequests"
                            />
                        </td>
                    </tr>
                </tbody>
            </kgr-table>
        </kgr-form-scaffold>
    </div>
</template>

<script>
import Checkbox from '../../../components/common/form/checkbox/Checkbox.vue';
import FormScaffold from '../../../components/common/form/FormScaffold.vue';
import KindergartenConfigRepository from '../../../js/repository/federation/KindergartenConfigRepository';
import Loading from '../../../components/common/Loading.vue';

export default {
    components: {
        'kgr-checkbox': Checkbox,
        'kgr-form-scaffold': FormScaffold,
        'kgr-loading': Loading,
    },
    props: {
        federationId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            pending: false,
            kindergartenConfigs: [],
            selectAllEditableVacationRequests: false,
        };
    },
    computed: {

    },
    created() {
        this.loadKindergartenConfigs(true);
    },
    methods: {
        loadKindergartenConfigs(loading) {
            this.loading = loading;
            KindergartenConfigRepository.find(this.federationId)
                .then((response) => this.kindergartenConfigs = response)
                .catch(() => this.$notify.error('Daten konnten nicht geladen werden'))
                .finally(() => {
                    this.loading = false;
                    this.pending = false;
                });
        },
        save() {
            this.pending = true;
            KindergartenConfigRepository.update(this.federationId, this.kindergartenConfigs)
                .then(() => {
                    this.$notify.success('saveChanges.success');
                    this.loadKindergartenConfigs(false);
                })
                .catch(() => this.$notify.error('saveChanges.error'));
        },
        translateKindergartenType(type) {
            if (type === null) {
                return '';
            }
            return this.$t(`kindergarten.${type}`);
        },
        translateFederalState(federalState) {
            if (federalState === null) {
                return '';
            }
            return this.$t(`germanFederalState.${federalState}`);
        },
        toggleEditableVacationRequests() {
            this.kindergartenConfigs.map((kindergartenConfig) => kindergartenConfig.editableVacationRequests = this.selectAllEditableVacationRequests);
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
